(function () {
    'use strict';

    angular.module('app.lostAndFound', [
        'app.core',
        'app.widgets'
    ]);
})();
